import React, { FC, useContext, useEffect } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { useBenefitEnrollmentFlow } from "../BenefitEnrollmentFlowModal"
import { Steps } from "../Workflow/Steps"
import { ButtonPrimary } from "../../../atoms/buttons/ButtonPrimary"
import { SendMessageFormContext } from "../../../../containers/talktocarrot/SendMessageFormContainer"
import { ThankYou } from "../../../talktocarrot/sendmessage/ThankYou"
import { useProgressTracker } from "../../ProgressTracker"
import { useFormContext } from "react-hook-form"
import { Button } from "../../../atoms/buttons/Button"
import { IlloUnderwaterPlants } from "../../../atoms/Illustrations"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { getHeap } from "../../../../../utils/heap"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()
const ViewName = Steps.PROCESS_CONNECT_INSURANCE_FAIL

const ProcessConnectInsuranceFailureView: FC = () => {
  const { sent, employeeEmail, personalEmail } = useContext(SendMessageFormContext)
  const { onExit } = useBenefitEnrollmentFlow()
  const { register, setValue } = useFormContext()
  const { setProgress } = useProgressTracker()

  useStateMachine(ViewName, null)
  setProgress(2, "CONNECT YOUR INSURANCE")

  const email = personalEmail ?? employeeEmail

  useEffect(() => {
    setValue("defaultMessage", "An error occurred when this member tried connecting to their health plan")
    setValue("email", email)
  }, [])

  return (
    <>
      {sent ? (
        <ThankYou close showHeader={false} showBottomLine={false} onClick={() => onExit()} />
      ) : (
        <>
          <div>
            <Spacer height={1.5} />
            <FlexRowCenter>
              <IlloUnderwaterPlants />
            </FlexRowCenter>
            <Spacer height={2} />
            <H2 variant="dark">{l`An unknown error occurred while trying to connect to your health insurance provider.`}</H2>
            <Spacer height={0.5} />
            <Body color="black-80">{l`You can try again or let us know about the issue so that we can help resolve it for you.`}</Body>
            <Spacer height={3} />
            <input hidden ref={register()} name="email" />
            <input hidden ref={register()} name="defaultMessage" />
            <ButtonBar />
          </div>
        </>
      )}
    </>
  )
}

const ButtonBar = () => {
  const { goBackToSpecificStep } = useStateMachine()
  const { onSubmit } = useContext(SendMessageFormContext)
  const {
    formState: { isSubmitting }
  } = useFormContext()

  const sendSupportRequest = () => {
    onSubmit()
    getHeap().track("EnrollmentFlowSupportRequest", { EventName: "Error occurred connecting to insurance" })
  }

  return (
    <div className="flex flex-row justify-center">
      <ButtonPrimary
        className="mr4"
        onClick={() => goBackToSpecificStep(Steps.INFO_CONNECT_INSURANCE)}
        enabled={true}
        disabledBackgroundColor="black-10"
      >
        Try connecting again
      </ButtonPrimary>
      <Button outline onClick={sendSupportRequest} enabled>
        {isSubmitting ? l`client.sending` : l`Send us a message`}
      </Button>
    </div>
  )
}

export { ProcessConnectInsuranceFailureView }
